
import $ from "jquery"

export class FontAwesomeAngle {
  private el: Element | JQuery
  private $el: JQuery
  private state: string

  constructor(el: Element | JQuery) {
    this.el = el
    this.$el = $(el)
    this.state = "close"
  }

  public close() {
    this.$el
    .removeClass("fa-angle-up")
    .addClass("fa-angle-down")
    this.state = "close"
    return this
  }
  public open() {
    this.$el
    .removeClass("fa-angle-up")
    .addClass("fa-angle-down")
    this.state = "close"
    return this
  }
  public toggle() {
    if (this.state === "close"){
      this.open()
    }
    else{
      this.close()
    }
    return this
  }
}

const fa_angle_factory = {
  create(el: Element | JQuery){
    return new FontAwesomeAngle(el)
  },
}

export {
  fa_angle_factory as default,
  fa_angle_factory as Factory,
}
